import { Flex, Title } from '@mantine/core';

import { ProjectSwitcher } from '@/features/project-switcher';
import { ThemeSwitcher } from '@/features/theme-switcher';

import { AdminMenu } from '../admin-menu/admin-menu';
import { SidebarList } from '../sidebar-list/sidebar-list';
import styles from './sidebar.module.scss';

export const Sidebar = () => {
  return (
    <Flex direction="column" className={styles.root} gap="lg">
      <Title order={2}>Админка</Title>
      <ProjectSwitcher />

      <SidebarList />

      <ThemeSwitcher />
      <AdminMenu />
    </Flex>
  );
};
